export const finalOutputSectionStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  paddingTop: 1,
  borderTop: `1px solid ${palette.divider}`,
});

export const emptyToolActivityStyles = ({ palette }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 3,
  borderRadius: 2,
  border: `1px dashed ${palette.divider}`,
  backgroundColor: palette.background.default,
  color: palette.text.secondary,
  textAlign: 'center',
});
